import { Button, Icon, Text } from "@ttc3k/trekker";
import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Copy } from "iconoir-react";
import { RecipeVariantProps } from "styled-system/types";
import { textRecipe } from "@ttc3k/trekker/dist/src/components/Typography/Text/recipe";

type CopyToClipboardProps = {
  text: string;
} & RecipeVariantProps<typeof textRecipe>;

export const CopyToClipboard = ({ text, ...props }: CopyToClipboardProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Button
      visual="unstyled"
      display="grid"
      gridTemplateColumns={"auto 1fr"}
      alignItems="center"
      gap="50"
      borderRadius={25}
      onClick={handleCopyToClipboard}
    >
      <Text
        visual="smallMedium"
        color="text.mid"
        opacity={0.75}
        textOverflow={"ellipsis"}
        overflow="hidden"
        whiteSpace="nowrap"
        {...props}
      >
        {text}
      </Text>
      {copied ? (
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{
            type: "spring",
            bounce: true,
            stiffness: 500,
            damping: 20,
            duration: 0.2,
          }}
        >
          <Icon Element={Check} color="icon.success.mid" size="sm" />
        </motion.div>
      ) : (
        <Icon Element={Copy} color="icon.disabled" size="sm" />
      )}
    </Button>
  );
};
